import { render, staticRenderFns } from "./StatisticsPlatform.vue?vue&type=template&id=dd0a56ec&scoped=true&"
import script from "./StatisticsPlatform.vue?vue&type=script&lang=js&"
export * from "./StatisticsPlatform.vue?vue&type=script&lang=js&"
import style0 from "./StatisticsPlatform.vue?vue&type=style&index=0&id=dd0a56ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd0a56ec",
  null
  
)

export default component.exports